import styled from "styled-components";

export const FooterContainer = styled.div`
  background-color: var(--color-brand-300);
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 16px;
  padding-right: 20px;

  .grid-parameterization-button-cancel{
    color: var(--color-contrast-white) !important;
    border-color: var(--color-contrast-white) !important;
    background-color: transparent !important;
    min-width: 'fit-content';
    width: 112px;
    border-radius: 2px;
    height: 28px;
    font-size: 12px;
  }

  .grid-parameterization-button-cancel:hover{
    opacity: 0.5;
  }
`;
